import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button } from 'antd';
import AuthInfo from '../../components/AuthInfo/AuthInfo';
import AuthForm from '../../components/AuthForm/AuthForm';
import EmailField from '../../components/SharedComponents/FormComponents/EmailField';
import FloatingLabel from '../../components/FloatingLabel/FloatingLabel';
import { sendVerificationLink } from '../../services/authApi/forgotPasswordApi';
import { toastNotify } from '../../utils/toastNotify';
import './ForgotPassword.scss';

const EnterEmail = () => {
  const [email, setEmail] = useState();
  const [viewForm, setViewForm] = useState(false);
  const [wrongEmailError, setWrongEmailError] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  let navigate = useNavigate();
  const onFinish = async (values) => {
    let formData = {
      email: values.email,
      phoneNumber: null,
      credentialType: "password",
    };
    setLoading(true);
    try {
      const userData = await sendVerificationLink(formData);
      if (!userData.isError) {
        localStorage.setItem("email", values.email);
        navigate("/forgot-password/activation");
      } else {
        toastNotify("error", userData?.message);
      }
    } catch (error) {
      const { response } = error;
      response?.data?.message === "Please enter a valid email and phone number" &&
        setWrongEmailError("No associated accounts");
      response?.data?.message !== "Please enter a valid email and phone number" &&
        toastNotify("error", error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className='auth auth--details auth--no-info-mobile login'>
      <AuthInfo
        className={viewForm ? 'hide' : null}
        title={<>Welcome back</>}
        description={<>Enter your credentials to access your Realbricks account.</>}
      >
        <div className='mobile-action' onClick={() => setViewForm(true)}>
          <Button className='w-100'>Get Started</Button>
        </div>
      </AuthInfo>
      <AuthForm
        className={viewForm ? 'show' : null}
        title={<>Forgot your password?</>}
        description={<>Enter the e-mail associated with your account for a link to reset your password.  </>}
      >
        <Form
          name='signup-form'
          className='auth-form details-form'
          onFinish={onFinish}
          // onFinishFailed={onFinishFailed}
          autoComplete='off'
          form={form}
        >
          <FloatingLabel label='Email' name='email' inputValue={email}>
            <EmailField
              email={email}
              setEmail={(value) => setEmail(value)}
              customeEmailError={wrongEmailError}
              clearCustomeEmailError={() => setWrongEmailError(undefined)}
            />
          </FloatingLabel>
          <Form.Item className='auth-form__fixed-submit' shouldUpdate>
            {() => (
              <Button 
                // href='/forgot-password/new-password' 
                htmlType='submit' 
                type='primary' 
                className='ant-btn-primary--alt'
                loading={loading}
                disabled={!form.isFieldsTouched(true) || form.getFieldsError().filter(({ errors }) => errors.length).length > 0}
              >
                Submit
              </Button>
            )}
          </Form.Item>
        </Form>
      </AuthForm>
    </div>
  );
};

export default EnterEmail;
